import React, { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap';
import HeaderLogo from '../../sharedComponents/Header/HeaderLogo';
import ResendActivationEmailForm from './ResendActivationEmailForm';

const ForgotPassword = () => {
  const logo = localStorage.getItem('branding') === "ARROWSTREAM" ? './arrowstreamLogoWhite.png' : process.env.REACT_APP_COMPANY_LOGO;

  return (
    <Fragment>
      <HeaderLogo logo={logo} />
      <Container fluid className='flex-grow-1'>
        <Row className='justify-content-center'>
          <Col style={{maxWidth: '400px'}}>
            <Row className='py-5'>
              <Col className='text-center text-size-30 main-header'>Resend Activation Email</Col>
            </Row>
            <Row>
              <Col className='text-muted pb-3'>If you have created an account, please enter your email below. If your account is found, we will resend you an email with an account activation link.</Col>
            </Row>
            <ResendActivationEmailForm />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ForgotPassword;